<template>
  <div>
    <vs-table
      :data="mutationRequests"
      pagination
      max-items="5"
      noDataText="Nog geen verzoeken"
    >
      <template slot="thead">
        <vs-th>Datum</vs-th>
        <vs-th>Wijziging</vs-th>
        <vs-th>Status</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].time">
            {{ data[indextr].time }}
          </vs-td>
          <vs-td :data="data[indextr].description">
            {{ data[indextr].description }}
          </vs-td>

          <vs-td :data="data[indextr].status">
            {{ $t(`Changes.${data[indextr].status}`) }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["mutationRequests"])
};
</script>

<style></style>
